export default "__VITE_ASSET__DgCBpHBe__"